import type { NarrowcastAPIClient } from '.';

export function createStubNarrowcastAPIClient(errorMessage: string): NarrowcastAPIClient {
    return {
        getNarrowcastMessageStatus: async () => {
            throw Error(errorMessage);
        },
        sendNarrowcastMessage: async () => {
            throw Error(errorMessage);
        },
        validateNarrowcastMessages: async () => {
            throw Error(errorMessage);
        },
    };
}
